import { Box, Typography } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { quoteModern } from "../style/style";

const formatCurrency = (value: number) => {
  return Number(value ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const QuoteTotalSummary = ({ quote }) => {
  const subtotal = quote?.subtotal ?? 0;
  const total = quote?.total ?? 0;

  return (
    <Box sx={{ ...quoteModern.cardSx, mt: 2.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={quoteModern.iconBoxSx}>
            <ReceiptLongIcon sx={{ fontSize: 18 }} />
          </Box>

          <Box>
            <Typography sx={quoteModern.labelSx}>Estimate summary</Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: 16,
                fontWeight: 800,
                color: quoteModern.colors.textPrimary,
              }}
            >
              Total estimate
            </Typography>

            <Typography
              sx={{
                mt: 0.4,
                fontSize: 12,
                color: quoteModern.colors.textSecondary,
              }}
            >
              Amount shown before final approval or invoice generation.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: "right", flexShrink: 0 }}>
          <Typography sx={quoteModern.labelSx}>Subtotal</Typography>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: 13,
              fontWeight: 700,
              color: quoteModern.colors.textSecondary,
            }}
          >
            ${formatCurrency(subtotal)}
          </Typography>

          <Typography
            sx={{
              mt: 0.8,
              fontSize: { xs: 22, md: 26 },
              fontWeight: 900,
              color: quoteModern.colors.orange,
              lineHeight: 1,
            }}
          >
            ${formatCurrency(total)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
